import { get, keyBy, uniq, flatten, set } from 'lodash';
// eslint-disable-next-line import/named
import { getProductions as getProductionsAPI, getPerformances as getPerformancesAPI, getList } from '../../utils/API';
import { queryClient, getLanguage } from '../../utils/queriesUtil';
import { conditionallyRemoveViewByFilters } from '../../utils/common';
import { PROFILES_ENDPOINT } from '../../constants/endpointConstants';

export const getProductionResults = async (query, pagination, page) =>
  getProductionsAPI({ approved_by: 'admin,company', ...query }, pagination).then(async response => {
    if (page !== 'artist') {
      return response.data;
    }
    const productionsIds = get(response, 'data.data', []).map(production => production?.id);
    const dates = await getList(`${PROFILES_ENDPOINT}/productions/dates`, {
      queryParams: {
        production_id: productionsIds,
        id: query.profile_id,
      },
    });
    const productions = get(response, 'data');
    const selectedDates = keyBy(dates?.data?.data, 'productionId');
    productions.data.forEach(p => {
      const allSelectedDates = uniq(flatten(Object.values(get(selectedDates, `${p?.id}.artistDates`, []))));
      set(
        p,
        'dates',
        get(p, 'dates', []).map(day => ({ ...day, performed: allSelectedDates.includes(day?.date) })),
      );
    });
    return productions;
  });

export const getProductions = async (query, pagination, page) => {
  const validQuery = conditionallyRemoveViewByFilters(query);
  const queryKey = [getLanguage(), 'GET_PRODUCTIONS', JSON.stringify({ ...validQuery, pagination })];
  if (typeof queryClient.getQueryData(queryKey) !== 'undefined') {
    return Promise.resolve(queryClient.getQueryData(queryKey));
  }
  const promise = await queryClient.fetchQuery(
    queryKey,
    async () => getProductionResults(validQuery, pagination, page),
    {
      refetchOnWindowFocus: false,
      staleTime: 0,
    },
  );
  return promise;
};

export const getPerformanceResults = async (query, pagination) =>
  getPerformancesAPI({ approved_by: 'admin,company', ...query }, pagination).then(response => {
    const performances = get(response, 'data');
    performances.data.forEach(performance => {
      performance.companies = [performance.company];
      performance.venues = [performance.venue];
      return performance;
    });
    return performances;
  });

export const getPerformances = async (query, pagination, page) => {
  const validQuery = conditionallyRemoveViewByFilters(query);
  const queryKey = [getLanguage(), 'GET_PERFORMANCES', JSON.stringify({ ...validQuery, pagination })];
  if (typeof queryClient.getQueryData(queryKey) !== 'undefined') {
    return Promise.resolve(queryClient.getQueryData(queryKey));
  }
  const promise = await queryClient.fetchQuery(
    queryKey,
    async () => getPerformanceResults(validQuery, pagination, page),
    {
      refetchOnWindowFocus: false,
      staleTime: 0,
    },
  );
  return promise;
};
